module.exports = __webpack_public_path__ + "static/pinkmummyme2-8f3b3b6d01975adf78592ce40ed9b1f6.png";